export enum ContentPromotionVenue {
  district = "district",
  school = "school",
}
